import { Component, OnInit, Input } from '@angular/core';
import { Rule, RuleList } from 'app/shared/models/action.models';
import { ActionService } from 'app/shared/services/action.service';
import { NewTask } from 'app/task-items/tasksData';
import { TaskListPDFCreator } from './case-task-pdf';
import { HttpClient } from '@angular/common/http';
import { SharedDataService } from '../../shared/services/shared-data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-case-tasks',
  templateUrl: './case-tasks.component.html',
  styleUrls: ['./case-tasks.component.css']
})
export class CaseTasksComponent implements OnInit {
  @Input() caseId: string | null = null;
  @Input() offerId: string | null = null;
  @Input() service: boolean = false;
  @Input() propertyId: string | null = null;
  item: NewTask | null = null;
  update: boolean = false;
  showMenu: boolean = false;
  isAdming: boolean = !!JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'SettingsAccess');
  useTemplate:boolean = false;
  templates: RuleList[];
  templateStep = 1;
  selectedRules:Rule[] = [];
  convertedRules:Rule[] = [];
  rulesAmount:number = 0;
  currentTemplate;
  templateIds = {};

  constructor(private action: ActionService, private http: HttpClient, private sharedData: SharedDataService, private translate: TranslateService) { }

  ngOnInit(): void {
  }

  prepareNewTask(template: boolean) {
    this.useTemplate = false;
    if(!!template) this.getTemplates();
    else {
      this.showMenu = false;
      this.item = new NewTask();
      document.getElementById('newTaskItemSliderModalBtn').click();
    }
  }

  getTemplates(){
    this.useTemplate = true;
    this.action.api.getTemplates().subscribe({
      next: (data: RuleList[]) => {
        this.templates = data.filter(x => !!x.rules.length).map(x => { return { ...x, rules: x.rules.map(y => { return { ...y, selected: false } }) } }).sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
        this.templates.forEach(x => { x.rules.forEach(y => this.templateIds[y.id] = x.id) });
      }
    });
  }

  newItem(newItem: boolean) {
    if(!!this.currentTemplate) {
      this.convertedRules.push(this.currentTemplate);
      this.selectedRules = this.selectedRules.filter(x => x.id != this.currentTemplate.id)
    }
    else this.update = newItem;
  }

  selectAll(t){
    if(t.rules.every(x => !!x.selected)) t.rules.forEach(x => x.selected = false)
    else t.rules.forEach(x => x.selected = true);
    this.getSelectedTemplates();
    console.log(this.templates)
  }

  templatesChosen(){
    if(!this.templates) return false
    this.templates.forEach(x => x.rules.forEach(y => {
      if(!!y.selected) return true
    }));
    return false
  }

  getSelectedTemplates(){
    let selected = [];
    for(let x of this.templates){
      x.rules.forEach(( current) => {
        if(!!current.selected) selected.push(current)
      });
    }
    this.selectedRules = selected;
  }

  resetTemplates(){
    this.useTemplate = false;
    this.templateStep = 1;
    this.selectedRules = [];
    this.convertedRules = [];
    this.rulesAmount = 0;
  }

  templateLoop(r:Rule){
    this.currentTemplate = r;
    //console.log(this.currentTemplate);
    let t = new NewTask();
    t.activityType = this.currentTemplate.activityTypeId
    t.caseId = this.caseId;
    t.offerId = this.offerId;
    t.propertyId = this.propertyId;
    t.templateId = null;
    t.description = this.currentTemplate.description;
    t.subject = this.currentTemplate.subject;
    t.durationInMinutes = this.currentTemplate.durationInMinutes;
    t.priorityId = this.currentTemplate.priority.id;
    t.recurrance = this.currentTemplate.recurrance;
    t.activityName = this.currentTemplate.name;
    t.assignedToStakeholder = localStorage.getItem('bearer');
    this.item = t;
    this.action.taskSubject.next(t)
    if(!document.getElementsByTagName('body')[0].classList.contains('modal-open')) document.getElementById('newTaskItemSliderModalBtn').click();
  }

  removeConvertedRule(ev:Event,i:number){
    console.log(ev)
    this.selectedRules.splice(i,1);
    console.log(this.selectedRules)
    ev.stopImmediatePropagation();
  }

  showPdf() {
    let a = new TaskListPDFCreator(this.http, this.sharedData, this.translate);
    let pdf = a.pdf.subscribe((data: any) => {
      if (!!data) {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          data.download();
        } else {
          data.open();
        }   
        pdf.unsubscribe();
      }
    });
    a.createPDF(this.propertyId);
  }

}
